module.exports = __webpack_public_path__ + "img/moins.e582974f.png";